<template lang="pug">
  .gvl-sign
    p Guten Tag {{ data.vorname }} {{ data.name }}
    p
      | wir freuen uns, Ihnen mitteilen zu dürfen, dass Ihr Antrag von der unabhängigen Fachjury positiv bewertet und bewilligt wurde.<br>
      | Nachfolgend finden Sie den für Sie vorbereiteten Stipendienvertrag.

    v-form(ref="sign-form" lazy-validation): v-row.mt-5
      v-col.pdf-container(cols="12")
        embed#pdf-view(:class="isFirefox && 'hide-top-pane'" :src="pdfUrl")

      v-col.mt-8(cols="12")
        h3 Vertrag elektronisch signieren:
        p.mb-0 Nachfolgend können Sie den Stipendienvertrag mit gedrückter linker Maustaste oder einem Touchpad-Stift digital unterzeichnen. Fehlerhafte Eingaben können über das X-Symbol am oberen rechten Rand des Unterschriftenfelds zurückgesetzt werden.
        n-sign-pad(
          v-model="data.sign"
          ref="sign"
          required
        )

      v-col.my-8(cols="12")
        p Mit dem Klick auf die Schaltfläche "Vertrag absenden" wird Ihre Unterschrift an unseren Server gesendet und digital in den Vertrag eingefügt. Anschließend erhalten Sie eine von der GVL gegengezeichnete Version des Vertrags automatisch per E-Mail zugesandt.
        v-btn(color="primary" :disabled="!pdfUrl" block @click="onSubmit") Vertrag absenden

    .overlay-spinner(v-if="loading")
      v-progress-circular(
        :size="60"
        color="#ccc"
        indeterminate
      )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],
})
export default class Sign extends Vue {
  @Prop({ type: String, default: '' }) token

  data = {}
  isFirefox = false
  pdfUrl = ''
  loading = false

  created () {
    this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
    this.$store.dispatch('setSignMode', true)
    if (this.isSigned) {
      this.gotoRoute('finish')
      return
    }

    this.loadConfig()
  }

  loadConfig () {
    this.$axios
      .get(Urls.GetConfig)
      .then(res => {
        this.$store.dispatch('setDisabledUrl', res.data.antrag_disabled_url)

        if (res.data.antrag_disabled_url) {
          // this.gotoRoute('disabled')
          location.href = res.data.antrag_disabled_url
        } else {
          this.loadAntragData()
        }
      })
  }

  b64toBlob (b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })
    return blob
  }

  loadAntragData () {
    const params = {
      token: this.token
    }

    this.$axios
      .get(Urls.GetAntrag, params)
      .then(res => {
        this.data = res.data || {}

        if (this.data.pdf_preview) {
          const blob = this.b64toBlob(this.data.pdf_preview, 'application/pdf')
          this.pdfUrl = `${ window.URL.createObjectURL(blob) }#toolbar=0&navpanes=0&scrollbar=0`
        }
      })
      .catch(err => {
        this.$toast.error('Fehler', err.message || 'Failed to get antrag data')
        this.pdfUrl = ''
      })
  }

  onSubmit () {
    const errorField = this.getFirstErrorField('sign-form')
    if (errorField) {
      this.scrollToErrorField(errorField)
      return
    }

    const signPad = this.$refs.sign
    if (!signPad || !signPad.isValid()) {
      this.scrollToErrorField(signPad)
      return
    }

    const params = {
      token: this.token,
      sign: this.data.sign.toString().replace('data:image/png;base64,', ''),
      bank_vorname_name: this.data.bank_vorname_name,
      bank_iban: this.data.bank_iban.toString().toUpperCase(), // .replace(/[-\s]/g, ''),
      bank_bic: this.data.bank_bic.toString().toUpperCase(),
    }

    this.loading = true

    this.$axios
      .post(Urls.Sign, params)
      .then(() => {
        this.$toast.success('Success', 'Succesfully saved')
        this.setSigned(true)
        this.gotoRoute('finish')
      })
      .catch(err => {
        this.$toast.error('Fehler', err.message || 'Failed to save data')
      })
      .finally(() => {
        this.loading = false
      })
  }

  scrollToErrorField (errorField) {
    const header = document.getElementById('gvl-header')
    const offset = header ? header.clientHeight : 0

    window.scrollTo({
      top: this.getElementTop(errorField.$el) - (offset + 50),
      behavior: 'smooth'
    })

    if (errorField.type === 'text') {
      errorField.focus()
    }
  }
}
</script>

<style lang="sass">
.pdf-container
  position: relative
  height: 600px
  overflow: hidden

  #pdf-view
    position: absolute
    top: 0
    left: 0
    width: 100%
    border: 0
    height: 100%
    z-index: 2

    &.hide-top-pane
      top: -32px
      height: calc(100% + 32px)

.upper-text input
  text-transform: uppercase
</style>
